module.exports = __webpack_public_path__ + "static/img/img1.f61bc36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img1.png
// module id = Bd7I
// module chunks = 1